import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import formatTonnage from '/shared/functions/formatTonnage';
import formatCarbonIntensity from '/shared/functions/formatCarbonIntensity';

import getElectConsumptionDataStatsSelector from '/business/shared/state/selectors/application/electricityHeatSteam/getElectConsumptionDataStatsSelector';
import getElectCarbonIntensitySelector from '/business/shared/state/selectors/application/electricityHeatSteam/getElectCarbonIntensitySelector';

function ConsumptionStats() {
  const { t } = useTranslation();
  const { totalCarbonEmissions } = useSelector(getElectConsumptionDataStatsSelector);
  const carbonIntensity = useSelector(getElectCarbonIntensitySelector);

  return (
    <>
      <div>
        <div>
          <strong>{formatTonnage(totalCarbonEmissions)}</strong>{' '}
          <span>{t('business:emissionFactors.emissionUnits.tonnageRaw')}</span>
        </div>
        <div>{t('questions:electricityHeatSteam.components.consumptionStats.absoluteEmissions')}</div>
      </div>
      <div>
        <div>
          <strong>{formatCarbonIntensity(carbonIntensity as number | null | undefined)}</strong>{' '}
          <span>
            {t('business:emissionFactors.emissionUnits.tonnageRaw')}/{t('business:emissionFactors.areaUnitsSm.m2')}
          </span>
        </div>
        <div>{t('questions:electricityHeatSteam.components.consumptionStats.carbonIntensity')}</div>
      </div>
    </>
  );
}

export default ConsumptionStats;
